<template>
    <div class="qksm qksm7">
        <h4>七、一般公共预算财政拨款“三公”经费支出情况说明</h4>
        <div class="nogap">
            <p><b>（一）“三公”经费支出执行情况说明。</b></p>
            <p>
                2020年度“三公”经费支出预算为{{isMoney(T7.items_ys.三公总计)}}万元，支出决算为{{isMoney(T7.items.三公总计)}}万元，
                <template v-if="num(T7.items_ys.三公总计)==0">
                    年初无预算，
                </template>
                <template v-else>
                    完成预算的{{calcRatio(T7.items.三公总计,T7.items_ys.三公总计)}}，
                </template>
                其中：因公出国（境）费预算{{isMoney(T7.items_ys.因公出国)}}万元，支出决算为{{isMoney(T7.items.因公出国)}}万元，
                <template v-if="num(T7.items_ys.因公出国)==0">
                    年初无预算；
                </template>
                <template v-else>
                    完成预算的{{calcRatio(T7.items.因公出国,T7.items_ys.因公出国)}}；
                </template>
                公务用车购置及运行费预算{{isMoney(T7.items_ys.公务用车)}}万元，支出决算为{{isMoney(T7.items.公务用车)}}万元，
                <template v-if="num(T7.items_ys.公务用车)==0">
                    年初无预算；
                </template>
                <template v-else>
                    完成预算的{{calcRatio(T7.items.公务用车,T7.items_ys.公务用车)}}；
                </template>
                公务接待费预算{{isMoney(T7.items_ys.公务接待)}}万元,支出决算为{{isMoney(T7.items.公务接待)}}万元，
                <template v-if="num(T7.items_ys.公务接待)==0">
                    年初无预算。
                </template>
                <template v-else>
                    完成预算的{{calcRatio(T7.items.公务接待,T7.items_ys.公务接待)}}。
                </template>
            </p>
            <p><b>（二）“三公”经费支出具体执行情况说明。</b></p>
            <p>
                2020年度“三公”经费支出决算中，因公出国（境）费支出决算{{isMoney(T7.items.因公出国)}}万元，占{{getPercentValue(T7.prop.map(e=>e.value), 0, 2)}}；
                公务用车购置及运行费支出决算{{isMoney(T7.items.公务用车)}}万元，占{{getPercentValue(T7.prop.map(e=>e.value), 1, 2)}}；
                公务接待费支出决算{{isMoney(T7.items.公务接待)}}万元，占{{getPercentValue(T7.prop.map(e=>e.value), 2, 2)}}。
                具体情况如下：
            </p>
            <p>
                1.因公出国（境）费支出{{isMoney(T7.items.因公出国)}}万元。全年使用一般公共预算财政拨款安排
                <template v-if="num(T7.items.因公出国)==0">
                    {{$store.state.divData.divname}}
                </template>
                <template v-else>
                    <reason type="textarea" style="width:200px;" classname="qksm" name="因公出国单位" v-model:value="qksm['因公出国单位']"></reason>单位
                </template>
                因公出国团组{{T7.统计数[0].f}}个，{{T7.统计数[0].k}}人次。
            </p>
            <p>
                2.公务用车购置及运行费支出{{isMoney(T7.items.公务用车)}}万元。其中：公务用车购置支出{{isMoney(T7.items.购置费)}}万元，购置公务用车{{T7.统计数[1].f}}辆；
                公务用车运行费支出{{isMoney(T7.items.运行费)}}万元，公务用车保有量为{{T7.统计数[1].k}}辆。
            </p>
            <p>
                3.公务接待费支出{{isMoney(T7.items.公务接待)}}万元（其中：全部为国内接待费）。其中：接待{{T7.统计数[2].f}}批次，接待{{T7.统计数[2].k}}人次。
            </p>
            <p><b>（三）“三公”经费增减变化情况说明。</b></p>
            <p>
                2020年度“三公”经费支出决算数比上年决算数
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="三公总计去年" v-model:value="T7.items_last.三公总计"></reason>万元）
                </span>
                {{growthValueText(T7.items.三公总计,T7.items_last.三公总计)}}万元，
                <template v-if="T7.items.三公总计!=T7.items_last.三公总计 && num(T7.items_last.三公总计)==0">
                    上年无决算。
                </template>
                <template v-else>
                    {{growthRatioText(T7.items.三公总计,T7.items_last.三公总计)}}。
                </template>
                其中：因公出国（境）费支出决算数比上年数
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="因公出国去年" v-model:value="T7.items_last.因公出国"></reason>万元）
                </span>
                {{growthValueText(T7.items.因公出国,T7.items_last.因公出国)}}万元，
                <template v-if="T7.items.因公出国!=T7.items_last.因公出国 && num(T7.items_last.因公出国)==0">
                    上年无决算
                </template>
                <template v-else>
                    {{growthRatioText(T7.items.因公出国,T7.items_last.因公出国)}}
                </template>
                ，主要原因是
                <template v-if="T7.items.因公出国==0 && num(T7.items_last.因公出国)==0">
                    我单位没有因公出国（境）费支出。
                </template>
                <reason v-else type="textarea" classname="qksm semicolon" name="因公出国原因" v-model:value="qksm['因公出国原因']"></reason>
                公务用车购置及运行维护费支出决算数比上年数
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="公务用车去年" v-model:value="T7.items_last.公务用车"></reason>万元）
                </span>
                {{growthValueText(T7.items.公务用车,T7.items_last.公务用车)}}万元，
                <template v-if="T7.items.公务用车!=T7.items_last.公务用车 && num(T7.items_last.公务用车)==0">
                    上年无决算
                </template>
                <template v-else>
                    {{growthRatioText(T7.items.公务用车,T7.items_last.公务用车)}}
                </template>
                ，主要原因是
                <reason type="textarea" classname="qksm semicolon" name="公务用车原因" v-model:value="qksm['公务用车原因']"></reason>
                公务接待费支出决算数比上年数
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="公务接待去年" v-model:value="T7.items_last.公务接待"></reason>万元）
                </span>
                {{growthValueText(T7.items.公务接待,T7.items_last.公务接待)}}万元，
                <template v-if="T7.items.公务接待!=T7.items_last.公务接待 && num(T7.items_last.公务接待)==0">
                    上年无决算
                </template>
                <template v-else>
                    {{growthRatioText(T7.items.公务接待,T7.items_last.公务接待)}}
                </template>
                ，主要原因是
                <template v-if="T7.items.公务接待==0 && num(T7.items_last.公务接待)==0">
                    我单位没有公务接待费支出。
                </template>
                <reason v-else type="textarea" classname="qksm widest" name="公务接待原因" v-model:value="qksm['公务接待原因']"></reason>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm7",
        data() {
            var qksm = this.$store.state.divData.qksm
            for (var prop in this.T7.items_last) {
                let v = qksm[prop + '去年'];
                if (v)
                    this.T7.items_last[prop] = v;
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm
            }
        },

        props: {
            T7: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };
</script>